import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationAttendeesReducer} from '../../utils/types';
//actions
import {getAttendee, getAttendeesList, getAttendeesStatistics} from './actions';
//operations
import {
	pendingOperation,
	rejectedOperation,
	getAttendeesStatisticsOperation,
	clearAttendeesDataOperation,
	getAttendeesListOperation,
	getAttendeeOperation,
	clearAttendeeOperation,
} from './operations';
//constants
import {initialOrganizationData} from '@/utils/constants';

export const initialState: IOrganizationAttendeesReducer = {
	attendeesList: initialOrganizationData,
	attendee: null,
	attendeesStatistics: null,
	isLoading: false,
};

const organizationAttendeesStore = createSlice({
	name: 'organizationAttendees',
	initialState,
	reducers: {
		clearAttendeesData: (state) => clearAttendeesDataOperation(state, initialState),
		clearAttendee: (state) => clearAttendeeOperation(state),
	},
	extraReducers: (builder) => {
		builder.addCase(getAttendeesList.pending, pendingOperation);
		builder.addCase(getAttendeesList.fulfilled, getAttendeesListOperation);
		builder.addCase(getAttendeesList.rejected, rejectedOperation);

		builder.addCase(getAttendee.pending, pendingOperation);
		builder.addCase(getAttendee.fulfilled, getAttendeeOperation);
		builder.addCase(getAttendee.rejected, rejectedOperation);

		builder.addCase(getAttendeesStatistics.pending, pendingOperation);
		builder.addCase(getAttendeesStatistics.fulfilled, getAttendeesStatisticsOperation);
		builder.addCase(getAttendeesStatistics.rejected, rejectedOperation);
	},
});

export const {clearAttendeesData, clearAttendee} = organizationAttendeesStore.actions;

export default organizationAttendeesStore.reducer;
